module.exports = __webpack_public_path__ + "img/high_citadel_of_necromancy_small.dc93f6de.png";